import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import unionSvg from '../assets/union.svg'

@customElement('facs-toast')
export class FacsToast extends LitElement {
    @property({ type: Boolean })
    visible = false;

    @property()
    message = 'Thank you for the feedback!';

    @property()
    variant: 'success' | 'neutral' = 'success';

    private _timer: ReturnType<typeof setTimeout> | null = null;

    show(duration = 3000) {
        this.visible = true;
        if (this._timer) clearTimeout(this._timer);
        this._timer = setTimeout(() => { this.visible = false; }, duration);
    }

    render() {
        return html`
            <div class="toast ${this.visible ? 'show' : ''} ${this.variant}">
                <span class="check">
                    <img src="${unionSvg}" class="icon" alt="union" />
                </span>
                <p class="toast-message">
                    ${this.message}
                </p>
            </div>
        `;
    }

    static styles = css`
    :host { display: contents; }

    .toast.success {
        background: #00892F;
    }

    .toast.neutral {
        background: #555555;
        width: fit-content;
    }

    .toast {
        position: fixed;
        bottom: 1.5rem;
        left: 50%;
        transform: translateX(-50%) translateY(6rem);
        opacity: 0;
        color: #fff;
        font-weight: 500;
        padding: 0.875rem;
        border-radius: 0.25rem;
        display: flex;
        align-items: center;
        gap: 1.25rem;
        z-index: 1100;
        box-shadow: 0 0.25rem 0.75rem rgba(0,0,0,0.2);
        transition: transform 0.3s ease, opacity 0.3s ease;
        white-space: nowrap;
        width: 100%;
        max-width: 34.5rem;
    }

    .toast.show {
        transform: translateX(-50%) translateY(0);
        opacity: 1;
    }

    .check {
        font-size: 1rem;
        display: flex; 
    }

    .toast-message {
        font-size: 1rem;
        line-height: 100%; 
        font-weight: 600;
        margin: 0;
    }
`;
}